import * as mutation from '../store/mutation-types'

function windowTitleProp () {
  return {
    get: function () {
      return this.$store.getters.windowTitle(this.windowId)
    },
    set: function (val) {
      this.$store.commit(mutation.WINDOW_TITLE, {
        windowId: this.windowId,
        title: val,
        emit: true
      })
    }
  }
}

export default windowTitleProp



// WEBPACK FOOTER //
// ./src/utils/windowTitleProp.js